import * as React from 'react';

import { Card } from 'components/common';
import type { Evidence, EvidenceFilters } from 'security-app/components/Investigations/Details/TimelineSegment/types';
import { isLogEvidence } from 'security-app/components/Investigations/Details/TimelineSegment/Utils';
import EvidenceFallbackCard from 'security-app/components/Investigations/Details/TimelineSegment/EvidenceOverview/EvidenceFallbackCard';

import { evidenceCardId } from './EvidenceCardFoundation';
import EvidenceLogCard from './EvidenceLogCard';
import EvidenceEventCard from './EvidenceEventCard';

const EvidenceCard = ({
  evidence,
  isInView,
  onShowSimilar,
  onResetShowSimilar,
  similarFieldsFilter,
  hasMessageStreamAccess,
  hasEventsStreamAccess,
}: {
  evidence: Evidence;
  isInView: boolean;
  onShowSimilar: (targetEvidence: Evidence) => Promise<void>;
  onResetShowSimilar: () => void;
  similarFieldsFilter: EvidenceFilters['similar'] | undefined;
  hasMessageStreamAccess: boolean;
  hasEventsStreamAccess: boolean;
}) => {
  const sharedProps = {
    onResetShowSimilar: onResetShowSimilar,
    onShowSimilar: onShowSimilar,
    similarFieldsFilter: similarFieldsFilter,
  };

  return (
    <Card padding="sm" id={evidenceCardId(evidence.id)} tabIndex={0}>
      {isInView && (
        <>
          {(() => {
            if (isLogEvidence(evidence)) {
              return hasMessageStreamAccess ? (
                <EvidenceLogCard {...sharedProps} evidence={evidence} />
              ) : (
                <EvidenceFallbackCard evidence={evidence} />
              );
            }

            return hasEventsStreamAccess ? (
              <EvidenceEventCard {...sharedProps} evidence={evidence} />
            ) : (
              <EvidenceFallbackCard evidence={evidence} />
            );
          })()}
        </>
      )}
    </Card>
  );
};

export default EvidenceCard;
